import * as React from 'react'
import { LabelDiv } from './LabelDiv'
import { Provider } from 'react-redux'
import { mockState, createMockStore } from 'mockState'

export const LabelDivExamples = () => {
  return (
    <div className="LabelDivExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <LabelDiv />
      </Provider>
    </div>
  )
}
